<template>
  <div id="GoTop"
       @click="GoTop()">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div>
</template>
<script>
  export default {
    name: "GoTop",
    data() {
      return {
        flag: false
      }
    },
    methods: {
      GoTop() {
        ;(function smoothscroll() {
          var currentScroll =
            document.documentElement.scrollTop || document.body.scrollTop
          if (currentScroll > 0) {
            window.requestAnimationFrame(smoothscroll)
            window.scrollTo(0, currentScroll - currentScroll / 10)
          }
        })()
      }
    }
  }
</script>
<style lang="scss">
  #GoTop {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 99999999;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.3);
    // box-shadow: 0 0 20px 0 rgba(197, 198, 205, 0.4);
    .glyphicon {
      line-height: 50px;
      text-align: center;
    }
    border-radius: 6px;
  }
  #GoTop > span {
    display: block;
    width: 100%;
    height: 100%;
    color: rgba(255, 255, 255, 0.8);
    font-size: 18px;
  }
  .glyphicon-chevron-up:before {
  }
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue